// Утилита для работы с согласием на cookies (баннер)

const COOKIE_CONSENT_NAME = 'cookie_consent';
/** ≈ 6 месяцев (30 дней × 6) */
const COOKIE_CONSENT_EXPIRY_DAYS = 180;
/** Дублируем в localStorage: часть браузеров/режимов режет `document.cookie`, localhost / смена хоста. */
const LOCAL_STORAGE_CONSENT_KEY = 'mistral_promo_cookie_banner_accepted_v1';

/**
 * Для аналитики (Метрика и т.д.): по ТЗ баннер пока не влияет на работу метрики —
 * всегда считаем, что технически можно инициализировать счётчики.
 * Согласие пользователя по кнопке «Принять» хранится отдельно — см. hasCookieBannerBeenAccepted().
 */
export function hasCookieConsent() {
  return true;
}

function readLocalBannerAccepted() {
  try {
    return localStorage.getItem(LOCAL_STORAGE_CONSENT_KEY) === '1';
  } catch {
    return false;
  }
}

/**
 * Пользователь нажал «Принять» в cookie-баннере (cookie `cookie_consent=true` или метка в localStorage).
 */
export function hasCookieBannerBeenAccepted() {
  const v = getCookie(COOKIE_CONSENT_NAME);
  if (v === 'true' || v === '1') return true;
  return readLocalBannerAccepted();
}

/**
 * Сохраняет согласие на использование cookies (6 месяцев).
 */
export function setCookieConsent() {
  const expiryDate = new Date();
  expiryDate.setTime(expiryDate.getTime() + COOKIE_CONSENT_EXPIRY_DAYS * 24 * 60 * 60 * 1000);
  setCookie(COOKIE_CONSENT_NAME, 'true', expiryDate);
  try {
    localStorage.setItem(LOCAL_STORAGE_CONSENT_KEY, '1');
  } catch (e) {
    console.warn('cookieConsent: cannot write localStorage', e);
  }
}

function getCookie(name) {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1);
    if (c.indexOf(nameEQ) !== 0) continue;
    const raw = c.substring(nameEQ.length);
    try {
      return decodeURIComponent(raw.trim());
    } catch {
      return raw.trim();
    }
  }
  return null;
}

function setCookie(name, value, expiryDate) {
  const maxAgeSec = Math.max(0, Math.floor((expiryDate.getTime() - Date.now()) / 1000));
  const segments = [
    `${name}=${encodeURIComponent(value)}`,
    `expires=${expiryDate.toUTCString()}`,
    `Max-Age=${maxAgeSec}`,
    'path=/',
    'SameSite=Lax',
  ];
  if (typeof window !== 'undefined' && window.location?.protocol === 'https:') {
    segments.push('Secure');
  }
  document.cookie = segments.join('; ');
}

export function loadYandexMetrika() {
  // Яндекс.Метрика подключается в index.html; функция оставлена для совместимости вызовов.
}
